<template>
  <div class="header">
    <div
      class="inner clearfix"
      :class="{'en-inner':isEnglish}"
    >
      <div class="left fl clearfix">
        <a-button
          class="back-btn fl"
          @click="goBackList"
        >
          {{ $t('message["282"]') }}
        </a-button>
        <!-- <a-breadcrumb
          v-if="crumb"
          separator="/"
          class="breadcrumb fl"
        >
          <a-breadcrumb-item>
            <a
              href="javascript:;"
              class="btn-text"
              @click="goBackList"
            >线索管理</a>
          </a-breadcrumb-item>
        </a-breadcrumb> -->
      </div>
      <div class="code-box">
        <span class="code">{{ code }}</span>
        <span
          v-if="permissionInfo.is_synced_xiaoman"
          class="assoc-xiaoman"
        >已同步至小满</span>
      </div>
      <a-dropdown v-if="showOperate">
        <a class="ant-dropdown-link operate fr"> {{ $t('message["79"]') }}
          <i class="iconfont iconicon-test69" />
        </a>
        <a-menu
          v-if="permissionInfo"
          slot="overlay"
          @click="onClickDropdown"
        >
          <a-menu-item
            v-if="permissionInfo && permissionInfo.is_show_archive"
            key="archive"
          >
            {{ $t('message["417"]') }}
          </a-menu-item>
          <!-- <a-menu-item key="transfer">转移</a-menu-item> -->
          <a-menu-item
            v-if="permissionInfo && permissionInfo.is_show_apply"
            key="apply"
          >
            {{ $t('message["1621"]') }}
          </a-menu-item>
          <a-menu-item
            v-if="permissionInfo && permissionInfo.is_show_xiaoman"
            key="assocToXiaoman"
          >
            同步至小满
          </a-menu-item>
          <a-menu-item
            v-if="permissionInfo && permissionInfo.is_show_del"
            key="delete"
          >
            <span class="fs-red">{{ $t('message["962"]') }}</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getLang } from '@/lib/storage'
export default {
  name: 'DetailHeader',
  components: {
  },
  props: {
    crumb: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ''
    },
    inquiryId: {
      type: [String, Number],
      default: ''
    },
    menuDatas: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      confirmLoading: false
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', [
      'permissionInfo'
    ]),
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    permissionMenuList () {
      const { permissionMenuList = {} } = this.menuDatas
      return permissionMenuList
    },
    showOperate () {
      const { is_show_archive: isShowArchive, is_show_apply: isShowApply, is_show_del: isShowDel, is_show_xiaoman: isShowXiaoman } = this.permissionInfo || {}
      return isShowArchive || isShowApply || isShowDel || isShowXiaoman
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  methods: {
    ...mapActions('inquery/detailData', [
      'deleteDetail',
      'inquirySyncxiaoman',
      'getArchiveTypes'
    ]),
    getLang,
    goBackList () {
      this.$emit('backList')
    },
    onClickDropdown ({ key }) {
      switch (key) {
        case 'archive':
          this.handleArchive()
          break
        case 'transfer':
          break
        case 'apply':
          this.$emit('handleApply')
          break
        case 'delete':
          this.handleDelete()
          break
        case 'assocToXiaoman':
          this.handleAssocToXiaoman()
          break
      }
    },
    successBackRoute () {
      let name = ''
      if (this.from === 'audit') {
        name = 'InqueryAudit'
      } else if (this.from === 'checkrepeat') {
        name = 'InqueryRepeat'
      } else {
        name = 'InqueryList'
      }
      // if (this.from === 'notice') { // 从通知消息跳转到的详情页
      //   this.$router.push({ name: 'recordNotice' })
      // } else {
      //   this.$router.push({
      //     name,
      //     query: {
      //       type: this.type,
      //       from: this.from
      //     }
      //   })
      // }
      if (this.from && this.type) {
        this.$router.push({
          name,
          query: {
            type: this.type,
            from: this.from
          }
        })
      } else if (this.from === 'notice') {
        this.$router.push({ name: 'recordNotice' })
      } else if (this.from === 'webhook') {
        this.$router.push({
          name: 'configSendRecord',
          params: {
            hookid: this.$route.query.hookid
          }
        })
      } else if (this.from === 'clue') {
        this.$router.push({
          name: 'InqueryClue',
          params: {
            id: this.$route.query.clue_id
          }
        })
      } else if (this.from === 'ocpc') {
        this.$router.push({
          name: 'ocpc'
        })
      } else {
        this.$router.go(-1)
      }
    },
    async handleArchive () {
      const chain = await this.getArchiveTypes()
      chain.onSuccess(raw => {
        this.$refs.achiveModalShow.showHide(true)
      })
    },

    handleDelete () {
      this.$confirm({
        title: this.$t('message["493"]'),
        content: this.$t('message["969"]') + '？',
        okText: this.$t('message["915"]'),
        okType: 'danger',
        cancelText: this.$t('message["896"]'),
        onOk: async () => {
          const chain = await this.deleteDetail()
          chain
            .onSuccess((raw, res) => {
              if (!res.error) {
                this.successBackRoute()
              }
            })
            .params({
              inquiryid: this.inquiryId
            })
            .fetch()
        },
        onCancel () {
          // console.log('Cancel')
        }
      })
    },

    async handleAssocToXiaoman () {
      if (this.confirmLoading) return

      this.confirmLoading = true
      let chain = await this.inquirySyncxiaoman({
        inquiryid: this.inquiryId
      })
      chain
        .onSuccess(res => {
          this.confirmLoading = false
          this.$bus.$emit('getFollowupList')
        }).onNetSuccess(res => {
          this.confirmLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  min-width: 1280px;
  min-height: 56px;
  line-height: 56px;
  background-color: #fff;
  border-bottom: solid 1px $gray4;
  .inner {
    position: relative;
    width: 1280px;
    margin: 0 auto;
  }
  .en-inner {
    .left {
      width: 360px;
    }
  }
  .left {
    width: 200px;
  }
  .back-btn {
    margin-top: 12px;
  }
  .code-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 50%;
    margin: auto;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    .code {
      vertical-align: middle;
    }
  }
  .assoc-xiaoman {
    height: 16px;
    line-height: 16px;
    margin-left: 8px;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 400;
    color:#B3B3B3;
    vertical-align: middle;
    border-radius: 12px;
    border: 1px solid #B3B3B3;
  }
  ::v-deep .ant-breadcrumb {
    width: auto;
    height: 56px;
    line-height: 56px;
  }
  .operate {
    cursor: pointer;
  }
}
/* @media screen and (max-width: 1200px) {
  .header .inner {
    padding: 0 20px;
  }
} */
</style>
